// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__WyIxL","dot1":"styles_dot1__YHsPB","dot2":"styles_dot2__lvcEu","dot3":"styles_dot3__PzAy1","loadingDot":"styles_loadingDot__JRAkN"};